export default "__VITE_ASSET__T4xHk8Jl__"